export enum WorkspacePrimitiveVisibility {
    PRIVATE = 'Private',
    SHARED = 'Shared',
    TEAM = 'Team',
    WORKSPACE = 'Workspace',
}

export enum WorkspaceSubjectType {
    SEARCH_COMPANY = 'search-company',
    IMPORTED_ENTITY = 'imported-entity',
    INVESTMENT = 'investment',
    FOLDER = 'folder',
    MEMO = 'memo',
    PIPELINE = 'pipeline',
    DASHBOARD = 'dashboard',
    LIST = 'list',
    LIFECYCLE = 'lifecycle',
    REPORT = 'report',
    TASK = 'task',
    TEAM = 'team',
}

export const WatchlistVisibilityType = WorkspacePrimitiveVisibility;
export type WatchlistVisibilityType = WorkspacePrimitiveVisibility;

export interface Watchlist {
    archived: boolean;
    canEdit: boolean;
    createdAt: string;
    description?: string | null;
    favorited: boolean;
    id: string;
    itemCount: number;
    locked: boolean;
    teamId?: string | null;
    title: string;
    updatedAt: string;
    visibility: WorkspacePrimitiveVisibility;
}

export interface SubjectReference {
    metadata?: Record<string, unknown>;
    subjectId: string;
    subjectLabel?: string | null;
    subjectType: WorkspaceSubjectType;
}

export interface WatchlistItem extends Required<Pick<SubjectReference, 'subjectId' | 'subjectType'>> {
    createdAt: string;
    id: string;
    metadata: Record<string, unknown>;
    subjectLabel?: string | null;
    updatedAt: string;
}

export interface WatchlistWithItems extends Watchlist {
    items: WatchlistItem[];
}

export interface SubjectWatchlist extends Watchlist {
    itemId?: string;
    selected: boolean;
}

export interface WatchlistInput {
    archived?: boolean;
    description?: string | null;
    favorited?: boolean;
    locked?: boolean;
    teamId?: string | null;
    title: string;
    visibility?: WorkspacePrimitiveVisibility;
}

export interface Tag {
    assignmentCount: number;
    assignmentId?: string;
    canEdit: boolean;
    color?: string | null;
    createdAt: string;
    id: string;
    name: string;
    parentId?: string | null;
    teamId?: string | null;
    updatedAt: string;
    visibility: WorkspacePrimitiveVisibility;
}

export interface TagInput {
    color?: string | null;
    name: string;
    parentId?: string | null;
    teamId?: string | null;
    visibility?: WorkspacePrimitiveVisibility;
}

export interface SubjectTags extends Required<Pick<SubjectReference, 'subjectId' | 'subjectType'>> {
    tags: Tag[];
}
